import { useTranslation } from 'react-i18next';
import { OptionChips } from './OptionChips';

interface ProactiveFeaturesFieldProps {
  value: boolean | null;
  inheritedValue: boolean;
  onChange: (nextValue: boolean | null) => void;
}

export function ProactiveFeaturesField({
  value,
  inheritedValue,
  onChange,
}: ProactiveFeaturesFieldProps) {
  const { t } = useTranslation('assistant');
  const onLabel = t('configuration.proactive.on');
  const offLabel = t('configuration.proactive.off');
  return (
    <OptionChips
      label={t('configuration.proactive.label')}
      options={[
        {
          value: null,
          label: t('configuration.defaultOption', {
            value: inheritedValue ? onLabel : offLabel,
          }),
        },
        { value: true, label: onLabel },
        { value: false, label: offLabel },
      ]}
      selectedValue={value}
      onSelect={onChange}
    />
  );
}
